import React, { createContext, useState, useContext, useEffect } from 'react';

const AuthContext = createContext();

export function AuthProvider({ children }) {
  // 1. CRITICAL FIX: Synchronously initialize user from localStorage. 
  // This prevents the split-second "null" state that kicks you to the login screen.
  const [user, setUser] = useState(() => {
    const storedUser = localStorage.getItem('user');
    try {
        return storedUser ? JSON.parse(storedUser) : null;
    } catch (e) {
        return null;
    }
  });
  
  const [token, setToken] = useState(localStorage.getItem('token'));
  const [isImpersonating, setIsImpersonating] = useState(localStorage.getItem('isImpersonating') === 'true');
  const [impersonatedOrg, setImpersonatedOrg] = useState(localStorage.getItem('impersonatedOrg'));
  
  // 2. CRITICAL FIX: Add a loading state that App.js ProtectedRoute is expecting
  const [loading, setLoading] = useState(false);

  // We no longer need the useEffect to load the user, as it's done synchronously above.

  const login = (userData, authToken) => {
    setUser(userData);
    setToken(authToken);
    localStorage.setItem('user', JSON.stringify(userData));
    localStorage.setItem('token', authToken);
  };

  const logout = () => {
    setUser(null);
    setToken(null);
    setIsImpersonating(false);
    setImpersonatedOrg(null);
    localStorage.clear(); 
  };

  const startImpersonation = (impersonationToken, targetOrgId, orgName, targetUserId, targetUserName) => { // <-- ADD targetUserName
    localStorage.setItem('originalToken', token); 
    localStorage.setItem('originalUser', JSON.stringify(user));
    
    const fakeUser = { 
        ...user, 
        id: targetUserId || user.id, 
        full_name: targetUserName || 'Client User', // <-- FIX: Adopts the client's real name
        org_id: targetOrgId, 
        org_name: orgName,
        is_system_admin: false, 
        admin_role: 'USER'      
    };

    // 3. Load the fake data into the main slot
    localStorage.setItem('token', impersonationToken); 
    localStorage.setItem('user', JSON.stringify(fakeUser));
    localStorage.setItem('isImpersonating', 'true');
    localStorage.setItem('impersonatedOrg', orgName);

    setToken(impersonationToken);
    setUser(fakeUser);
    setIsImpersonating(true);
    setImpersonatedOrg(orgName);
  };

  const stopImpersonation = () => {
    // 1. Grab the real Super Admin data from hiding
    const realToken = localStorage.getItem('originalToken');
    const realUser = localStorage.getItem('originalUser');
    
    if (realToken && realUser) {
        localStorage.setItem('token', realToken);
        localStorage.setItem('user', realUser);
        setToken(realToken);
        setUser(JSON.parse(realUser));
    }
    
    // 2. Destroy the fake Client data
    localStorage.removeItem('originalToken');
    localStorage.removeItem('originalUser');
    localStorage.removeItem('isImpersonating');
    localStorage.removeItem('impersonatedOrg');

    setIsImpersonating(false);
    setImpersonatedOrg(null);
  };

  return (
    <AuthContext.Provider value={{ 
        user, 
        token, 
        isImpersonating, 
        impersonatedOrg, 
        loading, // <-- ADDED: Export loading so ProtectedRoute doesn't crash
        login, 
        logout, 
        startImpersonation, 
        stopImpersonation 
    }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);